/**
 * @generated SignedSource<<18006c903bd130590c8458c4ad494ac3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type VirtualTryOnInput = {
  aspectRatio?: string | null;
  backgroundImageUrl?: string | null;
  backgroundPreset?: string | null;
  clothingImageUrl?: string | null;
  clothingPreset?: string | null;
  customPrompt?: string | null;
  effectPreset?: string | null;
  personImageUrl?: string | null;
  personPreset?: string | null;
  posePreset?: string | null;
  saveToLibrary: boolean;
};
export type tasksStartVirtualTryOnMutation$variables = {
  input: VirtualTryOnInput;
};
export type tasksStartVirtualTryOnMutation$data = {
  readonly startVirtualTryOn: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartVirtualTryOnMutation = {
  response: tasksStartVirtualTryOnMutation$data;
  variables: tasksStartVirtualTryOnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VirtualTryOnTask",
    "kind": "LinkedField",
    "name": "startVirtualTryOn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartVirtualTryOnMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "tasksStartVirtualTryOnMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7dd484b50c5c39545c4e8593ceceb880",
    "id": null,
    "metadata": {},
    "name": "tasksStartVirtualTryOnMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartVirtualTryOnMutation(\n  $input: VirtualTryOnInput!\n) {\n  startVirtualTryOn(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbaf49bb4024f6712d6cb074e33f44f8";

export default node;
